<template>
    <div class="g-upload">
        <!-- Progres Bar -->
        <template v-for="progressItem in uploadProgress" v-if="progress">
            <div class="progress" style="height: 2em;">
                <div
                    role="progressbar"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    :aria-valuenow="progressItem.progress"
                    class="progress-bar bg-success"
                    :style="'width:' + progressItem.progress + '%'"
                >
                    {{ progressItem.name }} -
                    {{ progressItem.size | humanFileSize }}
                </div>
            </div>
        </template>

        <!-- Uploader -->
        <div class="g-upload-btns" :class="{ 'file-drop-zone': dropZone }">
            <label class="btn btn-secondary">
                {{ label }}
                <input
                    ref="file"
                    type="file"
                    :id="id"
                    :data-test="'file-input-' + id"
                    :multiple="multiple"
                    @change="fileChange"
                />
            </label>
        </div>

        <!-- Errors -->
        <form-errors :errors="uploadErrors"></form-errors>
    </div>
</template>
<script>
import { fileInputFilter, humanFileSize, uploadToS3 } from '../util';
import { guessFileType } from '@jgile/laravel-vue/resources/js/lib/helpers';

export default {
    props: {
        id: {
            type: String,
            default: 'file',
        },
        value: {
            type: [Array, Object],
        },
        progress: {
            default: true,
        },
        dropZone: {
            default: false,
        },
        multiple: {
            default: false,
        },
        label: {
            default: 'Upload',
        },
        fileTypes: {
            type: [Array],
            default: null,
        },
        // Requires collection, model_id, model_name
        attachTo: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            data: {},
            files: [],
            uploadProgress: [],
            vaporResponse: null,
            uploadErrors: new SparkFormErrors(),
        };
    },
    filters: {
        humanFileSize,
    },
    methods: {
        fileInputFilter: fileInputFilter,
        fileChange() {
            const self = this;
            self.$emit('change', this.$refs.file.files);
            _.each(this.$refs.file.files, (file, key) => {
                self.validateFile(file).then((isValid) => {
                    if (isValid) {
                        return self.uploadToS3(file, key).then((response) => {
                            self.$emit('uploaded', response);
                            self.getPreview(response, file).then((response) => {
                                let item = _.get(response, 'data.data', _.get(response, 'data'));
                                item.size = file.size;
                                item.name = file.name;
                                item.file_name = file.name;

                                if (self.multiple) {
                                    self.files.push(item);
                                } else {
                                    self.$set(self, 'files', item);
                                }

                                if (window.livewire) {
                                    window.Livewire.dispatch('fileUploaded');
                                }

                                self.$emit('input', self.files);
                            });
                        });
                    }
                });
            });
        },
        validateFile(file) {
            return new Promise((resolve) => {
                if (this.fileTypes) {
                    let fileTypes = _.castArray(this.fileTypes);
                    let pass = _.includes(fileTypes, guessFileType(file));

                    if (!pass) {
                        this.setErrors([
                            'File must be ' +
                            [fileTypes.slice(0, fileTypes.length - 1 || 1).join(', ')]
                                .concat(fileTypes.slice().splice(-1, Number(fileTypes.length > 1)))
                                .join(' or '),
                        ]);
                    }

                    resolve(pass);
                } else {
                    resolve(true);
                }
            });
        },
        uploadToS3(file, key) {
            Vue.set(this.uploadProgress, key, {
                name: file.name,
                size: file.size,
                progress: 0,
            });

            return uploadToS3(file, {
                progress: (progress) => {
                    Vue.set(this.uploadProgress[key], 'progress', progress * 100);
                },
            })
                .then((response) => {
                    return response;
                })
                .catch((err) => {
                    this.setErrors(err);
                });
        },
        getPreview(vaporResponse, file) {
            if (this.attachTo && this.attachTo.collection_name && this.attachTo.model_name && this.attachTo.model_id) {
                return axios.post('/api/media', {
                    collection_name: this.attachTo.collection_name,
                    model_name: this.attachTo.model_name,
                    model_id: this.attachTo.model_id,
                    name: file.name,
                    extension: vaporResponse.extension,
                    hash: vaporResponse.etag,
                    key: vaporResponse.key,
                });
            } else {
                return axios.post('/api/uploads/temporary', {
                    key: vaporResponse.key,
                    hash: vaporResponse.etag,
                    extension: vaporResponse.extension,
                    mime_type: vaporResponse.headers['Content-Type'],
                });
            }
        },
        setErrors(errors) {
            this.uploadErrors.set(errors);
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                Vue.set(this, 'files', _.isNull(newValue) ? [] : newValue);
            },
        },
        data: {
            deep: true,
            handler(newData) {
                Vue.set(this.$refs.upload, 'data', newData);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.g-upload-btns .btn {
    cursor: pointer;
    color: #fff;
}

.g-upload-btns .btn input {
    display: none;
}

.progress {
    height: 2em;
    margin-bottom: 0.5em;
}

.file-drop-zone {
    border: 1px dashed #aaa;
    border-radius: 4px;
    height: 100%;
    text-align: center;
    vertical-align: middle;
    padding: 15px 5px;
    margin: 0;
}

.progress-bar {
    font-size: 1rem;
    color: #000;
    text-indent: 10px;
}

.image-preview {
    max-width: 80px;
    padding: 5px;
}

.button-delete {
    padding: 10px;
    position: relative;
    z-index: 2;
}
</style>
